import { registerDefault } from './base/registeredComponents'
registerDefault()

export * from './base/vsform'
export * from './base/vsdiff'
export * from './base/item'
export { RegisterComponent } from './base/registeredComponents'
export * from './schemamanager/schemaManager'
export * from './schemamanager/types'
export * from './schemamanager/twtypes'
export * from './schemamanager/themeColors'
export type { ElementProps } from './base/element'

export {
  DataTableToolbar,
  DetailComponentButtons
} from './helpers/datatableItems'
